import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { BasicTable } from '../../../components/Table/BasicTable';
import { StatisticsInfoRow } from './Reports.styled';
import { ReportsLayout } from './ReportsLayout';
import { StatisticsInfoItem } from './StatisticsInfoItem';
import {
  useWaitingListStatsColumns,
  useWaitingListStatsData,
} from './WaitingListStatsHooks';

export const WaitingListStats = () => {
  const { t } = useCommonTranslation();
  const tableColumns = useWaitingListStatsColumns();

  const { isLoading, entries, totalCount } = useWaitingListStatsData();

  return (
    <ReportsLayout
      isLeftCardLoading={isLoading}
      title={t('waiting-list')}
      leftColMD={4}
      leftCardNode={
        <>
          <StatisticsInfoRow style={{ marginBottom: '1rem' }}>
            <StatisticsInfoItem>
              {t('total-number-of-patients-in-waiting-list')}: {totalCount}
            </StatisticsInfoItem>
          </StatisticsInfoRow>
          <BasicTable
            columns={tableColumns}
            data={entries}
            isLoading={isLoading}
          />
        </>
      }
    />
  );
};
